var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 62C48.1208 62 62 48.1208 62 31C62 13.8792 48.1208 0 31 0C13.8792 0 0 13.8792 0 31C0 48.1208 13.8792 62 31 62Z",
    fill: "#0F7986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1094 47.9531C10.2402 47.9531 8.71875 46.4317 8.71875 44.5625V16.9531C8.71875 15.0839 9.7558 14.0469 11.625 14.0469H49.8906C51.7598 14.0469 53.2812 15.5683 53.2812 17.4375V44.5625C53.2812 46.4317 51.7598 47.9531 49.8906 47.9531H12.1094Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6021 17.9219C12.1371 17.9219 12.5708 17.4882 12.5708 16.9531C12.5708 16.4181 12.1371 15.9844 11.6021 15.9844C11.067 15.9844 10.6333 16.4181 10.6333 16.9531C10.6333 17.4882 11.067 17.9219 11.6021 17.9219Z",
    fill: "#CC584C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5083 17.9219C15.0433 17.9219 15.4771 17.4882 15.4771 16.9531C15.4771 16.4181 15.0433 15.9844 14.5083 15.9844C13.9733 15.9844 13.5396 16.4181 13.5396 16.9531C13.5396 17.4882 13.9733 17.9219 14.5083 17.9219Z",
    fill: "#FFD464"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4146 17.9219C17.9496 17.9219 18.3833 17.4882 18.3833 16.9531C18.3833 16.4181 17.9496 15.9844 17.4146 15.9844C16.8795 15.9844 16.4458 16.4181 16.4458 16.9531C16.4458 17.4882 16.8795 17.9219 17.4146 17.9219Z",
    fill: "#198058"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8989 17.4375C48.8989 17.7039 48.681 17.9219 48.4146 17.9219H20.3208C20.0544 17.9219 19.8364 17.7039 19.8364 17.4375V16.4688C19.8364 16.2023 20.0544 15.9844 20.3208 15.9844H48.4146C48.681 15.9844 48.8989 16.2023 48.8989 16.4688V17.4375Z",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3438 45.0469C51.3438 45.5797 50.9078 46.0156 50.375 46.0156H11.625C11.0922 46.0156 10.6562 45.5797 10.6562 45.0469V20.8281C10.6562 20.2953 11.0922 19.8594 11.625 19.8594H50.375C50.9078 19.8594 51.3438 20.2953 51.3438 20.8281V45.0469Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 43.1094C19.375 43.6422 18.9391 44.0781 18.4062 44.0781H13.5625C13.0297 44.0781 12.5938 43.6422 12.5938 43.1094V22.7656C12.5938 22.2328 13.0297 21.7969 13.5625 21.7969H18.4062C18.9391 21.7969 19.375 22.2328 19.375 22.7656V43.1094Z",
    fill: "#406A80"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4375 21.7969C48.9703 21.7969 49.4062 22.2328 49.4062 22.7656V27.6094C49.4062 28.1432 48.9703 28.5781 48.4375 28.5781H22.2812C21.7484 28.5781 21.3125 28.1432 21.3125 27.6094V22.7656C21.3125 22.2328 21.7484 21.7969 22.2812 21.7969H48.4375Z",
    fill: "#406A80"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4062 30.0312H21.3125V31H49.4062V30.0312Z",
    fill: "#B3B3B3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4062 31.4844H21.3125V32.4531H49.4062V31.4844Z",
    fill: "#B3B3B3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4062 32.9375H21.3125V33.9062H49.4062V32.9375Z",
    fill: "#B3B3B3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6094 34.3906H21.3125V40.6875H27.6094V34.3906Z",
    fill: "#B3B3B3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.875 34.3906H28.5781V40.6875H34.875V34.3906Z",
    fill: "#E16B5A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1406 34.3906H35.8438V40.6875H42.1406V34.3906Z",
    fill: "#B3B3B3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4062 34.3906H43.1094V40.6875H49.4062V34.3906Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.e0f568fe.svg";
export { ForwardRef as ReactComponent };